import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import { brandIsApproved } from "./businessRules/brandIsApproved";
export var accountVerificationNotApprovedVisibilityFn = function accountVerificationNotApprovedVisibilityFn(_context) {
  return Promise.resolve(!brandIsApproved());
};